import * as React from 'react';

import { enumLoadStatus } from '@rematter/frontend-lib-api-client';
import { cn, ContentCard, Widget } from '@rematter/ui-web';
import { useAtomValue } from 'jotai';

import { LoadPhaseToggle } from '../LoadPhaseToggle';
import { LoadRequestedMaterials } from '../materials/LoadRequestedMaterials';
import { LoadShippedMaterials } from '../materials/LoadShippedMaterials';

import { $materialsPhase } from '~/modules/brokerage/_state/brokeredLoadDetail.state';
import { BrokeredLoadRecord } from '~/modules/brokerage/types/brokeredLoad';

type Props = {
  load: BrokeredLoadRecord;
  onDiscard?: () => void;
  onSaveUpdates?: () => void;
};

export const BrokeredLoadTabMaterials: React.FC<Props> = ({
  load,
  onDiscard,
  onSaveUpdates,
}) => {
  const urlPhase = useAtomValue($materialsPhase);
  const activePhase =
    urlPhase ??
    (load.status === enumLoadStatus.Pending ? 'Requested' : 'Shipped');

  return (
    <div
      className={cn(
        '@BrokeredLoadTabMaterials',
        'flex h-full flex-col gap-5 overflow-hidden p-5',
      )}
    >
      <Widget className="relative flex w-full flex-shrink-0 items-center justify-between gap-2 px-5 py-4">
        <LoadPhaseToggle initialValue={activePhase} />
      </Widget>

      <ContentCard className="flex flex-col overflow-hidden rounded-lg p-0">
        {activePhase === 'Requested' ? (
          <LoadRequestedMaterials
            load={load}
            onDiscard={onDiscard}
            onSaveUpdates={onSaveUpdates}
          />
        ) : (
          <LoadShippedMaterials
            load={load}
            onDiscard={onDiscard}
            onSaveUpdates={onSaveUpdates}
          />
        )}
      </ContentCard>
    </div>
  );
};
